import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Watch } from "../models/watch";

export interface WatchFilter {
  name?: string;
  brandId?: number;
  minPrice?: number;
  maxPrice?: number;
  condition?: string;
  marketStatus?: string;
}

@Injectable({ providedIn: "root" })
export class WatchFilterService {
  buildQueryParams(filters: WatchFilter, limit: number): HttpParams {
    const includingInactives = filters?.condition === "all";
    return new HttpParams()
      .set("includingInactives", includingInactives.toString())
      .set("page", "0")
      .set("size", limit.toString());
  }

  applyFilters(watches: Watch[], filters?: any): Watch[] {
    if (!filters) return watches;

    return watches.filter((watch) => {
      const watchName = watch.name?.toLowerCase() ?? "";
      const watchPrice = watch.price ?? 0;

      return (
        (!filters.name || watchName.includes(filters.name.toLowerCase())) &&
        (!filters.brandId || watch.brand.id === filters.brandId) &&
        (!filters.minPrice || watchPrice >= filters.minPrice) &&
        (!filters.maxPrice || watchPrice <= filters.maxPrice) &&
        (!filters.condition || watch.itemCondition.name === filters.condition) &&
        (!filters.marketStatus || watch.marketStatus.name === filters.marketStatus)
      );
    });
  }
}
